import * as _boutique from './collections/boutique'
import * as _training from './collections/training'
import * as _twoToned from './collections/TwoToned'

export * from './Illustration'
export { _boutique as boutique, _training as training, _twoToned as twoToned }
